module.exports = __webpack_public_path__ + "static/media/anaAwardFuture-head-mobo.4de6f38e.png";